import script from "./re-authentication-data-provider.vue?vue&type=script&lang=js"
export * from "./re-authentication-data-provider.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__